import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  CurrencyServiceDetailSaveReqDTO,
  CurrencyServiceDetailSaveResDTO,
  CurrencyServiceDetailSearchReqDTO,
  CurrencyServiceDetailSearchResDTO,
  CurrencyServiceDetailUpdateResDTO,
  currencyServiceDetailUpdateReqDTO
} from 'src/models/Currency';
import { tourismClassifiedAPIRoutes } from '../tourism-classified';

export const CurrencyServiceDetail = createApi({
  reducerPath: 'CurrencyServiceDetail',
  tagTypes: ['CurrencyServiceTag'],
  baseQuery: fetchBaseQuery({
    baseUrl: tourismClassifiedAPIRoutes.baseUrl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('jwtToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: (builder) => ({
    savePageDetail: builder.mutation<
      CurrencyServiceDetailSaveResDTO,
      CurrencyServiceDetailSaveReqDTO
    >({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.CurrencyController.endpoint}/${tourismClassifiedAPIRoutes.CurrencyController.savePageDetail}`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['CurrencyServiceTag']
    }),

    updatePageDetail: builder.mutation<
      CurrencyServiceDetailUpdateResDTO,
      currencyServiceDetailUpdateReqDTO
    >({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.CurrencyController.endpoint}/${tourismClassifiedAPIRoutes.CurrencyController.updatePageDetail}`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['CurrencyServiceTag']
    }),

    findBySearchCriteria: builder.query<
      CurrencyServiceDetailSearchResDTO,
      CurrencyServiceDetailSearchReqDTO
    >({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.CurrencyController.endpoint}/${tourismClassifiedAPIRoutes.CurrencyController.findBySearchCriteria}`,
        method: 'POST',
        body
      }),
      providesTags: ['CurrencyServiceTag']
    }),

    findById: builder.mutation({
      query: (id) => ({
        url: `${tourismClassifiedAPIRoutes.CurrencyController.endpoint}/${tourismClassifiedAPIRoutes.CurrencyController.findById}/${id}`,
        method: 'GET'
      })
    }),
    getAllCurrencies: builder.mutation({
      query: (id) => ({
        url: `${tourismClassifiedAPIRoutes.CurrencyController.endpoint}/${tourismClassifiedAPIRoutes.CurrencyController.getAllCurrencies}`,
        method: 'GET'
      })
    }),

    deleteCurrencyDetail: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `${tourismClassifiedAPIRoutes.CurrencyController.endpoint}/${tourismClassifiedAPIRoutes.CurrencyController.deleteCurrencyDetail}/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['CurrencyServiceTag']
    })
  })
});
export const {
  useDeleteCurrencyDetailMutation,
  useFindByIdMutation,
  useFindBySearchCriteriaQuery,
  useSavePageDetailMutation,
  useUpdatePageDetailMutation,
  useGetAllCurrenciesMutation
} = CurrencyServiceDetail;
